import { usePosSetupStore } from "@/store/posSetupStore";
import type { FileOptions, RecordModel } from "pocketbase";
import { pb } from "@/utils/PocketBaseAdapter";
import { useUserStore } from "@/utils/UserStore";

const getPos = async() => {
  const posSetupStore = usePosSetupStore();
  const posSetup = await posSetupStore.load();
  return posSetup;
};

export const getBarCodeReader = async() => {
  const posSetup = await getPos();
  return posSetup?.barCodeReader || "";
};

export const getAccessReader = async() => {
  const posSetup = await getPos();
  return posSetup?.accessReader || "";
};

export const getPosPrinter = async() => {
  const posSetup = await getPos();
  return posSetup?.receiptPrinter || "";
};

export const getLocationPrinters = async(filter?: string) => {
  const locationFilter = `location="${useUserStore().currentLocation}"`;
  return pb.collection("printers").getFullList({
    filter: filter ? `${locationFilter} && ${filter}` : locationFilter,
    requestKey: null,
  });
};

export const getFileUrl = (
  record: RecordModel,
  fileName: string,
  options?: FileOptions | undefined,
) => {
  return pb.files.getUrl(record, fileName, options);
}
